import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcd3b360"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-view bg-image-md d-flex flex-column justify-content-center align-items-center col-12 py-3 py-md-5" }
const _hoisted_2 = { class: "col-12 d-flex p-2 p-md-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary d-none d-md-block col-1 col-lg-2 col-xl-3" }, null, -1))
const _hoisted_4 = { class: "bg-primary col-12 col-md-10 col-lg-8 col-xl-6 p-3 p-md-5 flex-centered-col bg-image" }
const _hoisted_5 = {
  style: {"max-width":"640px"},
  class: "col-12 rounded shadow bg-light px-3 px-md-5 py-3 py-md-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "col-12 m-0 mb-4 text-uppercase" }, "Log in", -1))
const _hoisted_7 = { class: "col-12 form py-1" }

import LoginForm from "@/components/forms/LoginForm.vue";
import { useHead } from "@unhead/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

useHead({
  title: "Login",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(LoginForm)
          ])
        ])
      ])
    ])
  ]))
}
}

})